<template>
  <div ref="root" class="videoControllers" data-app>
    <div class="videoControllers_left">
      <template v-if="mode === 'select'">
        <custom-check
          v-if="camera"
          :value="selected"
          :color="selectMode === 'capture' ? '#0075c2' : '#37a34a'"
          size="16px"
          :class="{
            ['videoControllers-check--capture']: selectMode === 'capture',
            ['videoControllers-check--trim']: selectMode === 'trim',
          }"
          class="videoControllers-check"
          @input="handleSelect"
          >{{ camera.name }}
        </custom-check>
      </template>
      <template v-if="mode === 'controller'">
        <span
          class="videoControllers_signal icon"
          :class="[
            { 'icon-wifi': signal === 3 },
            { 'icon-wifi-off': signal === 2 },
            { 'icon-sync': signal === 1 },
          ]"
        />
        <span class="videoControllers_title"> {{ title }} </span>
      </template>
    </div>
    <div
      v-if="showRight && mode === 'controller'"
      class="videoControllers_right"
    >
      <template v-if="!hideTools">
        <!-- <v-btn
          text
          color="secondary"
          class="videoControllers_item"
          :class="{ 'videoControllers_item-small': smallDisplay }"
        >
          <div class="videoControllers_item_icon icon icon-camera-control" />
          <div class="videoControllers_item_text">PTZ操作</div>
        </v-btn>
        <v-btn
          text
          color="secondary"
          class="videoControllers_item"
          :class="{ 'videoControllers_item-small': smallDisplay }"
        >
          <div class="videoControllers_item_icon icon icon-crop" />
          <div class="videoControllers_item_text">エリア選択</div>
        </v-btn>
        <v-btn
          text
          color="secondary"
          class="videoControllers_item"
          :class="{ 'videoControllers_item-small': smallDisplay }"
        >
          <div class="videoControllers_item_icon icon icon-mic" />
          <div class="videoControllers_item_text">マイク</div>
        </v-btn> -->
        <audio-control
          v-if="speakerSupport"
          ref="audio"
          v-model="volumeLevelModel"
          :speaker-on="speakerOnModel"
          :volume-on-right="volumeOnRight"
          :is-attach="isAttach"
          @onSpeakerOn="$emit('onSpeakerOn', $event)"
        >
          <template v-slot:activator="{ on, attrs, volume, menuOpen }">
            <v-btn
              text
              color="secondary"
              class="videoControllers_item"
              v-bind="attrs"
              :class="{
                'videoControllers_item-small': smallDisplay,
                'menu-close': !menuOpen,
              }"
              v-on="on"
            >
              <speaker-on-svg
                v-if="volume !== 0"
                class="videoControllers_item_icon icon"
                color="#37a34a"
                size="20px"
              />
              <speaker-off-svg
                v-else
                class="videoControllers_item_icon icon"
                color="#37a34a"
                size="20px"
              />
              <div class="videoControllers_item_text">スピーカー</div>
            </v-btn>
          </template>
        </audio-control>
        <v-tooltip
          v-else
          bottom
          content-class="videoControllers-speaker_tooltip "
        >
          <template v-slot:activator="{ on, attrs }">
            <img
              class="videoControllers_item_icon"
              v-bind="attrs"
              src="@/assets/img/ico_support_speaker.svg"
              v-on="on"
            />
          </template>
          <h2>音声非対応</h2>
        </v-tooltip>
      </template>
      <camera-menu
        v-if="showAbout"
        :show-auto-focus="showAutoFocus"
        :show-about="showAbout"
        :live-mode="liveMode"
        :small-display="smallDisplay"
        :menu-on-right="controllerOnRight"
        :is-attach="isAttach"
        button-class="videoControllers_menu-btn"
        @onAutofocus="$emit('onAutofocus')"
        @onLiveMode="handleChangeLiveMode"
        @onHelp="handleHelp"
      />
    </div>
  </div>
</template>

<script>
import CustomCheck from './inputs/CustomCheck.vue';
import { mapActions } from 'vuex';
import AudioControl from './AudioControl.vue';
import SpeakerOffSvg from './icons/SpeakerOffSVG.vue';
import SpeakerOnSvg from './icons/SpeakerOnSVG.vue';
import CameraMenu from './CameraMenu.vue';

export default {
  name: 'VideoControllers',
  components: {
    CustomCheck,
    AudioControl,
    SpeakerOffSvg,
    SpeakerOnSvg,
    CameraMenu,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    volumeLevel: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: 'large',
    },
    rootSize: {
      type: Object,
      default: () => ({
        width: '100%',
        height: '100%',
      }),
    },
    speakerSupport: {
      type: Boolean,
      default: false,
    },
    showAutoFocus: {
      type: Boolean,
      default: false,
    },
    showAbout: {
      type: Boolean,
      default: false,
    },
    signal: {
      // {1: sync, 2: wifi-off, 3: wifi}
      type: Number,
      default: 0,
    },
    showRight: {
      type: Boolean,
      default: true,
    },
    hideAbout: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: () => 'controller', // ['controller', 'select']
    },
    selectMode: {
      type: String,
      default: () => 'capture', // ['capture', 'trim']
    },
    camera: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    hideTools: {
      type: Boolean,
      default: false,
    },
    liveMode: {
      type: String,
      default: () => null,
    },
    speakerOn: {
      type: Boolean,
      default: false,
    },
    isAttach: {
      type: Boolean,
      default: false,
    },
    volumeOnRight: {
      type: Boolean,
      default: false,
    },
    controllerOnRight: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      narrow: false,
      forceSmallSize: false,
    };
  },
  computed: {
    smallDisplay() {
      return this.forceSmallSize || this.size == 'small';
    },
    volumeLevelModel: {
      get() {
        return this.volumeLevel;
      },
      set(val) {
        this.$emit('onVolume', val);
      },
    },
    speakerOnModel: {
      get() {
        return this.speakerOn;
      },
      set(val) {
        this.$emit('onSpeakerOn', val);
      },
    },
  },
  watch: {
    rootSize() {
      this.onResize();
    },
  },
  methods: {
    ...mapActions('help', ['setSelectedCam']),
    ...mapActions('video', ['setLowLatencyModeById']),
    handleChangeLiveMode(status) {
      const liveMode = status ? 'WebRTC' : 'HLS';
      this.$emit('onLiveMode', liveMode);
      this.setLowLatencyModeById({ id: this.camera.id, latencyMode: liveMode });
    },
    onResize() {
      if (this.$refs.root) {
        let offsetWidthCondition = 297;
        this.forceSmallSize =
          this.size === 'large' && this.$refs.root.offsetWidth < 519
            ? true
            : false;

        this.narrow = this.$refs.root.offsetWidth < offsetWidthCondition;
      }
    },
    handleSelect(e) {
      this.$emit('onSelect', e);
    },
    handleHelp() {
      this.setSelectedCam(this.camera);
      this.routerPush({
        name: 'help-cat-list',
        params: { id: '2', topic: '2' },
        query: { cam: this.camera.id },
      });
    },
  },
};
</script>

<style lang="scss">
.videoControllers {
  display: flex;
  justify-content: space-between;
  margin-top: 0;
  &-disabled {
    opacity: 0.8;
    pointer-events: none;
  }
  &-speaker_tooltip {
    &.v-tooltip__content {
      width: 72px;
      height: 20px;
      padding: 1px 6px 2px;
      border-radius: 6px;
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
      opacity: 0;
      background-color: #666666;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
      &:after,
      &:before {
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(102, 102, 102, 0);
        border-bottom-color: #666666;
        border-width: 5px;
        margin-left: -5px;
      }
      &:before {
        border-color: rgba(0, 0, 0, 0);
        border-bottom-color: #666666;
        border-width: 6px;
        margin-left: -6px;
      }
      &.menuable__content__active {
        opacity: 1 !important;
      }
    }
  }
  &-check {
    &--capture {
      &.customCheck {
        .customCheck_label {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #0075c2;
        }
      }
    }
    &--trim {
      &.customCheck {
        .customCheck_label {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #37a34a;
        }
      }
    }
  }
  &_left {
    align-items: center;
    height: 31px;
    width: 100%;
  }
  &_right {
    display: flex;
    align-items: center;
    color: var(--secondary-color);
    white-space: nowrap;
  }
  &_item {
    &_icon {
      margin-right: 5px;
    }
    &_text {
      font-weight: 600;
    }
    &.v-btn:not(.v-btn--round).v-size--default {
      height: 31px;
      padding: 0 5px;
    }
    &-small {
      font-size: 19px !important;
      min-width: 0 !important;
      padding: 0px 0px 0px 5px !important;
      .videoControllers_item_text {
        display: none;
      }
    }
  }
  &_menu-btn {
    &.v-btn:not(.v-btn--round).v-size--default {
      font-size: 16px;
      height: 31px;
      padding: 0 5px;
      min-width: 31px;
    }
    .icon {
      color: #c9cbd5;
    }
  }
  &_signal {
    &.icon-wifi {
      color: var(--secondary-color);
    }
    &.icon-wifi-off {
      color: #fc6d00;
    }
    &.icon-sync {
      color: var(--primary-color);
      width: 17px;
    }
  }
  &_title {
    font-size: 14px;
    font-weight: 600;
    font-weight: bold;
    color: var(--text-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 21px);
    padding-top: 7px;
    margin-left: 5px;
    display: inline-block;
    line-height: 1.1;
  }
}
</style>
